module.exports = {
      id: "bath-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.bfe893b5.svg#bath-usage",
      toString: function () {
        return this.url;
      }
    }